/* ==========================================================================
   Harmonia — comportements du thème
   Panier AJAX, tiroir, galerie, accordéons, offres, compte à rebours
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.Harmonia || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------- Monnaie -- */

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);

    function withComma(v) { return v.replace('.', ','); }

    if (fmt.indexOf('amount_no_decimals_with_comma_separator') > -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
    }
    if (fmt.indexOf('amount_with_comma_separator') > -1) {
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma(value));
    }
    if (fmt.indexOf('amount_no_decimals') > -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ------------------------------------------------------- Menu / burger -- */

  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;

    function open() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }

    $$('[data-mobile-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mobile-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------------------------------------------------- Accordéons -- */

  function initAccordions(root) {
    $$('[data-accordion-btn]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.dataset.open = String(!expanded);
      });
    });
  }

  /* -------------------------------------------------------------- Galerie -- */

  function initGalleries() {
    $$('[data-gallery]').forEach(function (gallery) {
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (!slides.length) return;
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === index);
          t.setAttribute('aria-selected', String(n === index));
        });
      }

      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      var prev = $('[data-gallery-prev]', gallery);
      var next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });

      // Balayage tactile
      var startX = null;
      gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });

      show(0);
    });
  }

  /* --------------------------------------------------------------- Offres -- */

  function initOffers() {
    $$('[data-offers]').forEach(function (form) {
      var offers = $$('[data-offer]', form);
      if (!offers.length) return;

      function sync() {
        var checked = $('input[name="id"]:checked', form);
        offers.forEach(function (o) {
          var input = $('input[name="id"]', o);
          o.classList.toggle('is-selected', !!input && input.checked);
        });
        if (!checked) return;

        // Certaines offres ajoutent plusieurs unités (ex : abonnement 3 boîtes)
        var qtyField = form.querySelector('input[name="quantity"]');
        var qty = parseInt(checked.dataset.qty, 10) || 1;
        if (qtyField) qtyField.value = qty;

        var price = checked.dataset.price;
        $$('[data-selected-price]').forEach(function (el) {
          if (price) el.textContent = formatMoney(parseInt(price, 10) * qty);
        });
        var btn = $('[data-atc]', form);
        if (btn) {
          var soldOut = checked.dataset.available === 'false';
          btn.disabled = soldOut;
          if (soldOut) btn.dataset.label = btn.textContent;
        }
      }

      offers.forEach(function (o) {
        o.addEventListener('click', function () {
          var input = $('input[name="id"]', o);
          if (input && !input.disabled) { input.checked = true; sync(); }
        });
        o.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); o.click(); }
        });
      });
      $$('input[name="id"]', form).forEach(function (i) { i.addEventListener('change', sync); });
      sync();
    });
  }

  /* ------------------------------------------------------ Compte à rebours */

  function initCountdown() {
    var els = $$('[data-countdown]');
    if (!els.length) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var text = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor(diff / 60) % 60) + ':' + pad(diff % 60);
      els.forEach(function (el) { el.textContent = text; });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------- Toast -- */

  var toastTimer = null;

  function showToast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    $('[data-toast-text]', t).textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  /* -------------------------------------------------------- Panier (AJAX) - */

  var drawer = null;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderShipBar(cart) {
    var bar = $('[data-ship-bar]', drawer);
    if (!bar || !cfg.freeShipping || !cfg.freeShipping.enabled) return;
    bar.hidden = cart.item_count === 0;
    if (!cart.item_count) return;
    var threshold = cfg.freeShipping.threshold || 0;
    var remaining = Math.max(0, threshold - cart.total_price);
    var pct = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
    $('[data-ship-bar-fill]', bar).style.width = pct + '%';
    var label = $('[data-ship-bar-text]', bar);
    if (remaining > 0) {
      bar.classList.remove('is-unlocked');
      label.innerHTML = 'Plus que <strong>' + formatMoney(remaining) + '</strong> pour la livraison offerte';
    } else {
      bar.classList.add('is-unlocked');
      label.textContent = '🎉 Livraison gratuite débloquée !';
    }
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    $$('[data-cart-qty]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;

    var body = $('[data-drawer-items]', drawer);
    var foot = $('[data-drawer-foot]', drawer);
    var empty = $('[data-drawer-empty]', drawer);

    if (!cart.items.length) {
      if (body) body.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      var emptyBar = $('[data-ship-bar]', drawer);
      if (emptyBar) {
        emptyBar.hidden = true;
        emptyBar.classList.remove('is-unlocked');
      }
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 6.5h15"/><path d="M8 6.5V5a1.5 1.5 0 0 1 1.5-1.5h5A1.5 1.5 0 0 1 16 5v1.5"/><path d="M6.2 6.5l.8 13a1.6 1.6 0 0 0 1.6 1.5h6.8a1.6 1.6 0 0 0 1.6-1.5l.8-13"/><line x1="10" y1="10.5" x2="10" y2="17"/><line x1="14" y1="10.5" x2="14" y2="17"/></svg>';

    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy" width="68" height="68">' : '';
      var variant = item.variant_title ? '<div class="line-item__variant">' + item.variant_title + '</div>' : '';
      return '' +
        '<div class="line-item" data-line="' + (i + 1) + '">' +
          '<div class="line-item__img">' + img + '</div>' +
          '<div class="line-item__body">' +
            '<div class="line-item__title">' + item.product_title + '</div>' + variant +
            '<div class="line-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="line-item__row">' +
              '<div class="qty">' +
                '<button type="button" data-qty="-1" aria-label="Retirer un article">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="Ajouter un article">+</button>' +
              '</div>' +
              '<button type="button" class="line-item__trash" data-remove aria-label="Retirer l’article">' + TRASH + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    var subtotal = $('[data-drawer-subtotal]', drawer);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    var total = $('[data-drawer-total]', drawer);
    if (total) total.textContent = formatMoney(cart.total_price);
    var ship = $('[data-drawer-shipping]', drawer);
    if (ship) {
      var free = cfg.freeShipping && cfg.freeShipping.enabled && cart.total_price >= cfg.freeShipping.threshold;
      ship.innerHTML = free ? '<span class="drawer__ship-free">GRATUITE</span>' : 'Calculée au paiement';
    }
    renderShipBar(cart);
  }

  function fetchCart() {
    return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(line, quantity) {
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function initDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;

    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
        fetchCart();
      });
    });
    $$('[data-cart-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    var overlay = $('.drawer__overlay', drawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    drawer.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]');
      if (!row) return;
      var line = parseInt(row.dataset.line, 10);
      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        var current = parseInt($('.qty span', row).textContent, 10);
        changeLine(line, Math.max(0, current + parseInt(qtyBtn.dataset.qty, 10))).then(function () {
          showToast('Quantité mise à jour');
        });
        return;
      }
      if (e.target.closest('[data-remove]')) {
        e.preventDefault();
        changeLine(line, 0).then(function () {
          showToast('Article retiré');
        });
      }
    });

    var promo = $('[data-promo]', drawer);
    if (promo) {
      promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('input', promo);
        var code = input.value.trim();
        if (!code) return;
        // Le code est memorise via /discount/<code> puis applique au paiement.
        fetch('/discount/' + encodeURIComponent(code)).then(function () {
          promo.classList.add('is-applied');
          $('button', promo).textContent = 'Appliqué ✓';
          showToast('Code promo appliqué au paiement');
        });
      });
    }

    fetchCart();
  }

  // Le tiroir s'ouvre AVANT la réponse serveur : on grise le contenu en place
  // et, si le panier était vide, on pose une ligne fantôme le temps de l'aller-retour.
  function startAdding() {
    if (!drawer) return;
    drawer.classList.add('is-adding');
    var empty = $('[data-drawer-empty]', drawer);
    if (empty) empty.hidden = true;
    var body = $('[data-drawer-items]', drawer);
    if (body && !body.children.length) {
      body.innerHTML =
        '<div class="line-item line-item--ghost" data-ghost aria-hidden="true">' +
          '<div class="line-item__img"></div>' +
          '<div class="line-item__body">' +
            '<div class="line-item__title"></div>' +
            '<div class="line-item__price"></div>' +
          '</div>' +
        '</div>';
    }
  }

  function stopAdding() {
    if (!drawer) return;
    drawer.classList.remove('is-adding');
    var ghost = $('[data-ghost]', drawer);
    if (ghost && ghost.parentElement) ghost.parentElement.removeChild(ghost);
  }

  function initAddToCart() {
    $$('[data-offers]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!cfg.cartDrawer) return; // laisse Shopify gérer la redirection panier
        e.preventDefault();
        var btn = $('[data-atc]', form);
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = '…'; }

        // Réaction immédiate : ne jamais faire attendre le réseau à l'utilisateur.
        openDrawer();
        startAdding();

        fetch(cfg.routes.cart_add, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            // Shopify peut répondre en HTML (page anti-bot 429, maintenance, coupure
            // réseau) : r.json() lèverait alors une erreur de parsing illisible.
            var type = r.headers.get('content-type') || '';
            if (!r.ok || type.indexOf('json') === -1) throw new Error('indisponible');
            return r.json();
          })
          .then(function (res) {
            if (res.status && res.status !== 200) throw new Error(res.description || res.message);
            return fetchCart();
          })
          .then(function () { showToast('Ajouté au panier'); })
          .catch(function (err) {
            // Échec : on remet le tiroir dans son état réel avant de le fermer, sinon
            // le client voit un panier vide et croit avoir perdu son article.
            fetchCart().catch(function () {});
            closeDrawer();
            showToast(err.message === 'indisponible'
              ? 'Ajout impossible pour le moment, réessayez dans quelques secondes.'
              : ((cfg.strings && cfg.strings.error) || 'Une erreur est survenue'));
          })
          .finally(function () {
            stopAdding();
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
          });
      });
    });
  }

  /* ------------------------------------------------------ Barre collante -- */

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-offers]');
    if (!bar || !anchor) return;

    var trigger = $('[data-atc]', anchor) || anchor;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    io.observe(trigger);

    var btn = $('[data-sticky-scroll]', bar);
    if (btn) {
      btn.addEventListener('click', function () {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* --------------------------------------------------------------- Vidéos - */

  function initVideos() {
    $$('[data-video-card]').forEach(function (card) {
      var video = $('video', card);
      var play = $('[data-video-play]', card);
      if (!video) return;
      video.muted = true;

      var mute = $('[data-video-mute]', card);
      if (mute) {
        mute.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          mute.classList.toggle('is-on', !video.muted);
        });
      }
      function toggle() {
        if (video.paused) {
          $$('video').forEach(function (v) { if (v !== video) v.pause(); });
          video.play();
          if (play) play.hidden = true;
        } else {
          video.pause();
          if (play) play.hidden = false;
        }
      }
      card.addEventListener('click', toggle);
      video.addEventListener('ended', function () { if (play) play.hidden = false; });
    });

    // Les vidéos ne tournent que lorsqu'elles sont visibles
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.hasAttribute('autoplay')) v.play().catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.15 });
      $$('.video-card video').forEach(function (v) { vio.observe(v); });
    }
  }

  /* ------------------------------------------- Préchargement des pages --- */

  function initPrefetch() {
    // Filet permanent, jamais désactivé : les Speculation Rules de theme.liquid
    // font mieux quand elles s'appliquent, mais Chrome les suspend dans plusieurs
    // cas hors de notre contrôle (préchargement désactivé par l'utilisateur,
    // économiseur de données, débogueur attaché). Couper ce prefetch sur la
    // simple présence de l'API ferait donc régresser ces visiteurs-là.
    var probe = document.createElement('link');
    if (!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;

    var done = {};
    function prefetch(url) {
      if (done[url]) return;
      done[url] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      document.head.appendChild(l);
    }
    function onIntent(e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname) return;
      if (/^\/(cart|checkout|account|discount)/.test(u.pathname)) return;
      prefetch(u.pathname + u.search);
    }
    document.addEventListener('mouseover', onIntent, { passive: true });
    document.addEventListener('touchstart', onIntent, { passive: true });
  }

  /* ------------------------------------------------------------- Révéler -- */

  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;

    function revealAll() { els.forEach(function (el) { el.classList.add('is-in'); }); }

    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    // Cascade : chaque élément d'un même parent apparaît avec un léger décalage
    els.forEach(function (el) {
      var sibs = el.parentElement ? el.parentElement.children : [];
      var idx = 0, found = 0;
      for (var i = 0; i < sibs.length; i++) {
        if (sibs[i].classList && sibs[i].classList.contains('reveal')) {
          if (sibs[i] === el) idx = found;
          found++;
        }
      }
      el.style.transitionDelay = Math.min(idx * 90, 540) + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });

    // Filet de sécurité : si rien n'a été révélé, on affiche tout.
    setTimeout(function () {
      if (!document.querySelector('.reveal.is-in')) revealAll();
    }, 1500);
  }

  /* ------------------------------------------------------------- Démarrage */

  function init() {
    // Chaque module est isolé : une erreur dans l'un ne doit jamais
    // empêcher les suivants de s'exécuter (le contenu en dépend).
    [
      initMobileNav, function () { initAccordions(document); }, initGalleries,
      initOffers, initCountdown, initDrawer, initAddToCart,
      initStickyAtc, initVideos, initReveal, initPrefetch
    ].forEach(function (fn) {
      try { fn(); } catch (err) {
        if (window.console) console.error('[Harmonia]', err);
      }
    });
  }

  // Page préchargée en arrière-plan (prerender) : on n'initialise rien tant
  // qu'elle n'est pas réellement affichée, sinon les minuteurs (pop-up, compte
  // à rebours) et les animations d'apparition tourneraient dans le vide.
  function start() {
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', init, { once: true });
      return;
    }
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-init dans l'éditeur de thème
  document.addEventListener('shopify:section:load', init);
})();
